import hitTemplate from './algolia-hit-template.js';
import searchHitTemplate from './algolia-search-hit-template.js';
import { colorFilterWidget } from './algolia-color-filter.js';
import { searchBoxWidget } from './algolia-search-box.js';
import { initQuickview } from './algolia-quickview.js';
import { initWishlist } from './algolia-wishlist.js';
import { infiniteHits } from './algolia-infinite-hits.js';
import { initAlgoliaMobileDrawer } from './algolia-mobile-drawer.js';

function restoreBrandCheckboxes() {
  const container = document.querySelector('.ais-facet-vendor');
  if (!container) return;

  container.querySelectorAll('.ais-RefinementList-item').forEach(item => {
    const label = item.querySelector('label');
    if (!label || label.querySelector('input[type="checkbox"]')) return;

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'ais-RefinementList-checkbox ais-facet--checkbox';
    checkbox.checked = item.classList.contains('ais-RefinementList-item--selected');
    label.insertBefore(checkbox, label.firstChild);
    checkbox.addEventListener('change', () => label.click());
  });
}

function observeBrandFacetCheckboxes() {
  const observer = new MutationObserver(() => {
    restoreBrandCheckboxes();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  restoreBrandCheckboxes();
}

function simplifyProductTypeFacetLabels() {
  document.querySelectorAll('.ais-facet-product_type .ais-RefinementList-label').forEach(labelEl => {
    const fullTextNode = Array.from(labelEl.childNodes).find(node => node.nodeType === 3);
    if (fullTextNode) {
      const parts = fullTextNode.textContent.split('>').map(p => p.trim());
      if (parts.length >= 2) {
        fullTextNode.textContent = `${parts[0]} ${parts[parts.length - 1]}`;
      } else {
        fullTextNode.textContent = parts[0];
      }
    }
  });
}

function observeProductTypeChanges() {
  const target = document.querySelector('.ais-facet-product_type');

  if (!target) return;

  const observer = new MutationObserver(() => {
    simplifyProductTypeFacetLabels();
  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
}

function restoreTypeCheckboxes() {
  const container = document.querySelector('.ais-facet-product_type');
  if (!container) return;

  container.querySelectorAll('.ais-RefinementList-item').forEach(item => {
    const label = item.querySelector('label');
    if (!label || label.querySelector('input[type="checkbox"]')) return;

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'ais-RefinementList-checkbox ais-facet--checkbox';
    checkbox.checked = item.classList.contains('ais-RefinementList-item--selected');
    label.insertBefore(checkbox, label.firstChild);
    checkbox.addEventListener('change', () => label.click());
  });
}

function observeTypeFacetCheckboxes() {
  const observer = new MutationObserver(() => {
    restoreTypeCheckboxes();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  restoreTypeCheckboxes();
}

function injectLoadingOverlay() {
  if (document.getElementById('algolia-loading-overlay')) return;

  const overlay = document.createElement('div');
  overlay.id = 'algolia-loading-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    background: rgba(255, 255, 255, 0.9);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const spinner = document.createElement('div');
  spinner.className = 'spinner';
  spinner.style.cssText = `
    width: 40px;
    height: 40px;
    border: 4px solid #ccc;
    border-top-color: #000;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  `;

  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `;

  overlay.appendChild(spinner);
  document.head.appendChild(style);
  document.body.appendChild(overlay);
}

function showLoadingOverlay() {
  const overlay = document.getElementById('algolia-loading-overlay');
  if (overlay) overlay.style.display = 'flex';
}

function hideLoadingOverlay() {
  const overlay = document.getElementById('algolia-loading-overlay');
  if (overlay) overlay.style.display = 'none';
}

function enhanceAlgoliaFacetsWithIcons() {
  document.querySelectorAll('.ais-facet-dropdown-wrapper').forEach(wrapper => {
    const isVendor = wrapper.classList.contains('ais-facet-vendor');
    const checkbox = wrapper.querySelector('.ais-dropdown-checkbox');
    const label = wrapper.querySelector('.ais-facet--header');
    const container = wrapper.querySelector('.ais-facet-dropdown-container');

    if (!checkbox || !label || !container) return;

    checkbox.checked = isVendor;

    let icon = label.querySelector('.facet-toggle-icon');
    if (!icon) {
      icon = document.createElement('span');
      icon.className = 'facet-toggle-icon';
      label.appendChild(icon);
    }

    const updateAccordion = () => {
      const isOpen = checkbox.checked;
      icon.textContent = isOpen ? '−' : '+';
      container.style.display = isOpen ? 'block' : 'none';
    };

    updateAccordion();

    checkbox.removeEventListener('change', updateAccordion);
    checkbox.addEventListener('change', updateAccordion);
  });
}

function restoreSizeCheckboxes() {
  const container = document.querySelector('.ais-facet-options\\.size');
  if (!container) return;

  container.querySelectorAll('.ais-RefinementList-item').forEach(item => {
    const label = item.querySelector('label');
    if (!label || label.querySelector('input[type="checkbox"]')) return;

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'ais-RefinementList-checkbox ais-facet--checkbox';
    checkbox.checked = item.classList.contains('ais-RefinementList-item--selected');
    label.insertBefore(checkbox, label.firstChild);
    checkbox.addEventListener('change', () => label.click());
  });
}

function observeSizeFacetCheckboxes() {
  const observer = new MutationObserver(() => {
    restoreSizeCheckboxes();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  restoreSizeCheckboxes();
}

export function initAlgolia(showSpinner = true) {
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',
    searchHitTemplate 
  );
  
  const hasAlgoliaInstantSearch = document.getElementById('algolia-shopify-instantsearch');
  if (!hasAlgoliaInstantSearch) {
    return;
  }

  console.log('Algolia custom hooks initialized');

  if (showSpinner) {
    injectLoadingOverlay();
    showLoadingOverlay();
  }

  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchProductTemplate',
    hitTemplate
  );

  algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function (defaultWidgets) {
    return defaultWidgets.filter(widget => widget.$$widgetType === 'ais.hits');
  });
  
  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', (params = {}) => {

    algoliaShopify.hooks.registerHook(
      'beforeInstantSearchStatsTemplate',
      function (_defaultTemplate, data, html) {
        return html`
          <strong>${algoliaShopify.helpers.formatNumber(data.nbHits)}</strong> result${data.nbHits !== 1 ? 's' : ''} found
        `;
      }
    );

    return [
      colorFilterWidget,
      searchBoxWidget,
      infiniteHits({
        container: document.querySelector('.ais-hits-container'),
        showPrevious: true,
        transformItems(items) {
          hideLoadingOverlay();
          const hits = document.querySelector('#algolia-shopify-instantsearch');
          if (hits) hits.classList.add('algolia-ready');
          return items;
        }
      }),
    ];
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function (params, facet) {
    if (facet.title === 'Brand') {
      return {
        ...params,
        transformItems(items) {
          return items
            .slice()
            .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
        }
      };
    }
  
    if (facet.title === 'Size') {
      const sizeOrder = [
        'XXS', 'XS', 'XS/S', 'S', 'S/M', 'M', 'M/L', 'L', 'L/XL', 'XL', 'XXL', 'XXXL',
        '1X', '2X', '2X/3X', '3X', '4X', '5X', '6X', '8X',
        '000', '00', '0', '1', '2', '3', '4', '5', '6', '8', '10', '12', '14', '16', '18', '20',
        '22', '24', '26', '28', '30', '32', '34', '36', '38', '40', '42', '44', '46'
      ];
  
      const normalize = (label) => {
        const usMatch = label.match(/^US\s?(\d{1,3})$/i);
        if (usMatch) return usMatch[1];
        return label.replace(/\s/g, '').toUpperCase();
      };
  
      return {
        ...params,
        transformItems: (items) => {
          return items.slice().sort((a, b) => {
            const aNorm = normalize(a.label);
            const bNorm = normalize(b.label);
            const aIndex = sizeOrder.indexOf(aNorm);
            const bIndex = sizeOrder.indexOf(bNorm);
            if (aIndex === -1 && bIndex === -1) return a.label.localeCompare(b.label);
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;
            return aIndex - bIndex;
          });
        }
      };
    }
  
    if (facet.title === 'Type') {
      const simplifyLabel = (label) => {
        const parts = label.split('>').map(part => part.trim());
        return parts.length >= 2 ? `${parts[0]} ${parts[parts.length - 1]}` : parts[0];
      };
  
      return {
        ...params,
        transformItems(items) {
          return items
            .slice()
            .sort((a, b) =>
              simplifyLabel(a.label).toLowerCase().localeCompare(simplifyLabel(b.label).toLowerCase())
            );
        }
      };
    }    
  
    return params;
  });

  initQuickview();
  initWishlist();

  setTimeout(() => {
    enhanceAlgoliaFacetsWithIcons();
    observeSizeFacetCheckboxes();
    observeTypeFacetCheckboxes();
    observeBrandFacetCheckboxes();
    initAlgoliaMobileDrawer();
    observeProductTypeChanges();
  }, 600);
}

document.addEventListener('algolia.hooks.initialize', initAlgolia);


